// Safari 3.0+ "[object HTMLElementConstructor]"
export const isSafari =
  navigator.userAgent.indexOf("Safari") !== -1 &&
  navigator.userAgent.indexOf("Chrome") === -1;
